import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'zeudy-youtube-subscribe-button',
  styleUrl: 'zeudy-youtube-subscribe-button.css',
  shadow: false,
})
export class zeudyYoutubeSubscribeButton {
  private textInput?: HTMLElement;

  @Prop() channel: string;
  @Prop() layout: string = 'default';
  @Prop() showCount: boolean;

  waitForApi(callback) {
    var interval = setInterval(function () {
      if (window?.gapi?.ytsubscribe) {
        clearInterval(interval);
        callback();
      }
    }, 50);
  }

  componentDidLoad() {
    const po = document.createElement('script');
    po.type = 'text/javascript';
    po.async = false;
    po.src = 'https://apis.google.com/js/platform.js';
    const s = document.getElementsByTagName('script')[0];
    s && s.parentNode.insertBefore(po, s);

    this.waitForApi(() => {
      window.gapi.ytsubscribe.render(this.textInput, {
        channelId: this.channel,
        layout: this.layout,
        count: this.showCount ? 'default' : 'hidden',
      });
    });
  }

  render() {
    return <div class="g-ytsubscribe" ref={el => (this.textInput = el as HTMLElement)}></div>;
  }
}
